import { useQuery } from '@tanstack/react-query';

import fetchProductVersion from '../apis/fetchProductVersion';

export default function useGetProductVersion(productDocId, versionId) {
  return useQuery({
    queryKey: ['getProductVersion', productDocId, versionId],
    queryFn: () => fetchProductVersion(productDocId, versionId),
    enabled: !!productDocId && !!versionId,
    staleTime: 10 * 60 * 1000,
  });
}
